(function (window, document) {
  "use strict";

  const componentName = "xt-gwp-monthly-upsell";
  const boundModals = new WeakSet();

  class GwpMonthlyUpsell extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;

      const root = this.attachShadow({ mode: "open" });
      root.innerHTML = `
        <style>
          :host {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }

          .xt-gwp-monthly-upsell {
            box-sizing: border-box;
            width: 100%;
            padding: 12px 18px;
            overflow: hidden;
            border: 1px solid #dbdbdb;
            border-radius: 3px;
            background: #f5f4f2;
            color: #000;
          }

          .xt-gwp-monthly-upsell__heading,
          .xt-gwp-monthly-upsell__body {
            margin: 0;
          }

          .xt-gwp-monthly-upsell__heading {
            font-family: var(--v20-display, var(--v20g-serif, Georgia, serif));
            font-size: 16px;
            font-weight: 400;
            line-height: normal;
          }

          .xt-gwp-monthly-upsell__body {
            margin-top: 8px;
            color: #333;
            font-family: var(
              --v20-body,
              var(--v20g-sans, var(--font-base), Inter, Arial, sans-serif)
            );
            font-size: 10px;
            font-weight: 400;
            line-height: 1.45;
          }

          .xt-gwp-monthly-upsell__actions {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-top: 7px;
          }

          .xt-gwp-monthly-upsell__switch,
          .xt-gwp-monthly-upsell__keep {
            appearance: none;
            min-height: 29px;
            margin: 0;
            border: 0;
            font-family: var(
              --v20-body,
              var(--v20g-sans, var(--font-base), Inter, Arial, sans-serif)
            );
            cursor: pointer;
          }

          .xt-gwp-monthly-upsell__switch {
            width: min(168px, 58%);
            border-radius: 3px;
            background: #000;
            color: #fff;
            font-size: 9px;
            font-weight: 600;
          }

          .xt-gwp-monthly-upsell__keep {
            padding: 0;
            background: transparent;
            color: #737373;
            font-size: 10px;
            font-weight: 400;
          }
        </style>
        <div class="xt-gwp-monthly-upsell" role="group" aria-labelledby="xt-gwp-monthly-upsell-heading">
          <h3 class="xt-gwp-monthly-upsell__heading" id="xt-gwp-monthly-upsell-heading">Buy 3 or 6 months. Get the brush, free.</h3>
          <p class="xt-gwp-monthly-upsell__body">Switch to 3-Month ($75 per bag) or 6-Month Delivery ($70 per bag) and the $35 Copper Paddle Brush ships free.</p>
          <div class="xt-gwp-monthly-upsell__actions">
            <button type="button" class="xt-gwp-monthly-upsell__switch">SWITCH TO 3 MONTHS</button>
            <button type="button" class="xt-gwp-monthly-upsell__keep">Keep monthly</button>
          </div>
        </div>
      `;

      root.querySelector(".xt-gwp-monthly-upsell__switch").addEventListener("click", () => {
        this.dispatchEvent(
          new CustomEvent("gwp:switch-to-three-months", {
            bubbles: true,
            composed: true,
          }),
        );
      });
      root.querySelector(".xt-gwp-monthly-upsell__keep").addEventListener("click", () => {
        this.dispatchEvent(
          new CustomEvent("gwp:keep-monthly", {
            bubbles: true,
            composed: true,
          }),
        );
      });
    }
  }

  if (!customElements.get(componentName)) {
    customElements.define(componentName, GwpMonthlyUpsell);
  }

  function setDismissed(storageKey) {
    if (!storageKey) return;

    try {
      sessionStorage.setItem(storageKey, "1");
    } catch (error) {}
  }

  function isPopupDismissed(storageKey) {
    try {
      return sessionStorage.getItem(storageKey) === "1";
    } catch (error) {
      return false;
    }
  }

  function bindPopup(modal) {
    if (boundModals.has(modal)) return;
    boundModals.add(modal);

    modal.querySelectorAll("[data-gwp-monthly-dismiss]").forEach((button) => {
      button.addEventListener("click", () => {
        setDismissed(modal.dataset.gwpMonthlyStorageKey);
        if (button.classList.contains("gwp-monthly-popup__keep-browsing")) {
          modal.hide();
        }
      });
    });

    modal.addEventListener("click", (event) => {
      if (event.target === modal) {
        setDismissed(modal.dataset.gwpMonthlyStorageKey);
      }
    });

    modal.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        setDismissed(modal.dataset.gwpMonthlyStorageKey);
      }
    });
  }

  function showPopup({ storageKey, trigger }) {
    if (!storageKey || isPopupDismissed(storageKey)) return false;

    const modal = document.getElementById("GwpMonthlyPopup");
    if (!modal || modal.hasAttribute("open") || typeof modal.show !== "function") {
      return false;
    }

    modal.dataset.gwpMonthlyStorageKey = storageKey;
    bindPopup(modal);
    modal.show(trigger);
    return true;
  }

  window.XtresseGwpMonthly = {
    isPopupDismissed,
    showPopup,
  };
})(window, document);
